module.exports = __webpack_public_path__ + "static/media/gf365-logo.b5be689c.svg";